import React, { useEffect, useState } from 'react';
import { xhrFormat } from '../../../common/api.endPoints';
import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { AdminDocumentType } from '../../../common/constants/adminDocumentType';
import { Resource } from '../../../common/constants/resource';
import { HttpService } from '../../../common/http.service';
import { IKeyValMap } from '../../../common/interfaces/IKeyValMap';
import styles from '../styles.module.scss';

export const AdminDocuments = ({
  policyId,
  product,
  carrier,
  documentType,
  downloadHandler,
  hideIfNotAvailable,
}: {
  policyId: number;
  product: string;
  carrier: string;
  documentType: AdminDocumentType;
  downloadHandler: (uri: string, fileName: string) => void;
  hideIfNotAvailable?: boolean;
}) => {
  const url = `document/policy/${policyId}/product/${product}/carrier/${carrier}/${documentType}`;
  const resource = ((docType: AdminDocumentType): string => {
    switch (docType) {
      case AdminDocumentType.POLICY_COMBINED:
        return Resource.POLICY_COMBINED;
      case AdminDocumentType.HIPAA_COMPLETED:
        return Resource.HIPAA_AUTH_FORM;
      case AdminDocumentType.RELEASE_TRANSFER_AUTHORIZATION:
        return Resource.RELEASE_TRANSFER_AUTHORIZATION;
    }
    return '';
  })(documentType);
  const onClick = async () => {
    await downloadHandler(url, `${policyId}-${documentType}.pdf`);
  };

  // Make request to the backend and hide the task if url is not present in the
  // response because not all applications have all the documents.
  const [available, setAvailable] = useState(true);
  useEffect(() => {
    (async () => {
      if (hideIfNotAvailable) {
        const response: IKeyValMap = await HttpService.getInstance().get(
          xhrFormat(url),
        );
        setAvailable(Boolean(response?.parsedBody?.url));
      }
    })();
  }, [hideIfNotAvailable, policyId, product, carrier, documentType]);

  if (hideIfNotAvailable && !available) {
    return null;
  }

  return (
    <>
      <FlexRow className={styles.Title}>
        <TitleSmall>{resource}</TitleSmall>
      </FlexRow>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          {resource}
        </FlexCol>
        <FlexCol lg={6} className={styles.TaskInfoCell}>
          <button type={'button'} className={styles.Document} onClick={onClick}>
            {`${policyId}-${documentType}.pdf`}
          </button>
        </FlexCol>
      </FlexRow>
    </>
  );
};
